import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { numericFormatter } from 'react-number-format';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import { Row } from '../../Resources';

import { loadFilters } from 'components/Filter/store/thunk';
import { loadProvisionalReceiptProductTables } from 'pages/ProvisionalReceiptProductConfig/store/thunk';

import { formatDocument, formatPhone, formatPostalCode } from 'helpers/formatters';

export default function NfeUpdate({ data, lastRegister, newRegister }) {
  const dispatch = useDispatch();

  const { establishmentId, observation, createdAt } = data;

  const oldConfigs = !!lastRegister?.automaticGenerateNfe ? lastRegister?.automaticGenerateNfe : {};
  const newConfigs = !!newRegister?.automaticGenerateNfe ? newRegister?.automaticGenerateNfe : {};

  const { userId } = useSelector(state => state.profile);
  const { selects } = useSelector(state => state.filters);

  const {
    tables: {
      streetType,
      taxationRegime,
      taxationRegimeSpecial,
      taxationSituations
    }
  } = useSelector(state => state.provisionalReceiptProductConfig);

  const paymentMethods = selects
    ?.find(filter => filter?.id == 'paymentMethod')
    ?.options;

  useEffect(() => {
    dispatch(loadProvisionalReceiptProductTables(userId));

    if(establishmentId) {
      dispatch(loadFilters(userId, establishmentId));
    }
  }, [establishmentId]);

  return(
    <Grid container>
      <Grid xs={12}>
        {!!observation ? (
          <Typography color='primary'>
            {observation} em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
          </Typography>
        ) : (
          <Typography color='primary'>
            Atualização em <b>{moment(createdAt, 'DD/MM/YYYY HH:mm:ss').format('LLL')}</b>
          </Typography>
        )}
      </Grid>
      <Grid xs={12} style={{ padding: 5 }}>
        <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <b>Configuração Anterior</b>
        </Typography>
        <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'companyName') && (
            <Row>
              <Typography color='primary'>
                <b>Razão Social</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.companyName}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'fantasyName') && (
            <Row>
              <Typography color='primary'>
                <b>Nome Fantasia</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.fantasyName}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'documentId') && (
            <Row>
              <Typography color='primary'>
                <b>CNPJ</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatDocument(lastRegister?.documentId)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'phone') && (
            <Row>
              <Typography color='primary'>
                <b>Telefone</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatPhone(lastRegister?.phone)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'email') && (
            <Row>
              <Typography color='primary'>
                <b>Email</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.email}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'stateSubscription') && (
            <Row>
              <Typography color='primary'>
                <b>Inscrição Estadual</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.stateSubscription}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'streetType') && (
            <Row>
              <Typography color='primary'>
                <b>Tipo do local</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {streetType?.find(type => +type?.value == +lastRegister?.streetType)?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'postalCode') && (
            <Row>
              <Typography color='primary'>
                <b>CEP</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatPostalCode(lastRegister?.postalCode)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'street') && (
            <Row>
              <Typography color='primary'>
                <b>Endereço</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.street}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'number') && (
            <Row>
              <Typography color='primary'>
                <b>Número</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.number}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'complement') && (
            <Row>
              <Typography color='primary'>
                <b>Complemento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.complement}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'city') && (
            <Row>
              <Typography color='primary'>
                <b>Cidade</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.city}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'district') && (
            <Row>
              <Typography color='primary'>
                <b>Bairro</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.district}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'state') && (
            <Row>
              <Typography color='primary'>
                <b>UF</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.state}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'simpleNational') && (
            <Row>
              <Typography color='primary'>
                <b>Simples Nacional</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.simpleNational == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'taxationRegime') && (
            <Row>
              <Typography color='primary'>
                <b>Regime Tributário</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationRegime?.find(type => +type?.value == +lastRegister?.taxationRegime)?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'taxationRegimeSpecial') && (
            <Row>
              <Typography color='primary'>
                <b>Regime Tributário Especial</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationRegimeSpecial?.find(type => +type?.value == +lastRegister?.taxationRegimeSpecial)?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'taxIncentive') && (
            <Row>
              <Typography color='primary'>
                <b>Incentivo Tributário</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.taxIncentive == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'encouraging') && (
            <Row>
              <Typography color='primary'>
                <b>Incentivador Cultural</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.encouraging == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'tokenCsc') && (
            <Row>
              <Typography color='primary'>
                <b>Token CSC</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.nfce?.tokenCsc}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'idTokenCsc') && (
            <Row>
              <Typography color='primary'>
                <b>ID Token</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {lastRegister?.nfce?.idTokenCsc}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'pisAliquot') && (
            <Row>
              <Typography color='primary'>
                <b>Alíquota PIS</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {numericFormatter(lastRegister?.nfce?.pisAliquot?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'pisCst') && (
            <Row>
              <Typography color='primary'>
                <b>CST Pis</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationSituations?.find(type => type?.value?.toString() == lastRegister?.nfce?.pisCst?.toString())?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'cofinsAliquot') && (
            <Row>
              <Typography color='primary'>
                <b>Alíquota Cofins</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {numericFormatter(lastRegister?.nfce?.cofinsAliquot?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister?.nfce || {}, 'cofinsCst') && (
            <Row>
              <Typography color='primary'>
                <b>CST Cofins</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationSituations?.find(type => type?.value?.toString() == lastRegister?.nfce?.cofinsCst?.toString())?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(oldConfigs || {}, 'serviceOrders') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as ordens de serviços pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.serviceOrders == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(oldConfigs || {}, 'invoices') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as faturas de cliente pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.invoices == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(oldConfigs || {}, 'selectedTransactions') && (
            <Row>
              <Typography color='primary'>
                <b>Emissão quando solicitada a nota fiscal</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+oldConfigs?.selectedTransactions == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(oldConfigs || {}, 'paymentMethods') && (
            <Row>
              <Typography color='primary'>
                <b>Meios de pagamento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {paymentMethods?.filter(paymentMethod => oldConfigs?.paymentMethods?.includes(+paymentMethod?.value))?.map(paymentMethod => paymentMethod?.label)?.join(', ') || '--'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(lastRegister || {}, 'nfeStatus') && (
            <Row>
              <Typography color='primary'>
                <b>NFe Status</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+lastRegister?.nfeStatus == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
        </Grid>
      </Grid>
      <Grid xs={12} style={{ padding: 5 }}>
        <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
          <b>Configuração Atual</b>
        </Typography>
        <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'companyName') && (
            <Row>
              <Typography color='primary'>
                <b>Razão Social</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.companyName}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'fantasyName') && (
            <Row>
              <Typography color='primary'>
                <b>Nome Fantasia</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.fantasyName}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'documentId') && (
            <Row>
              <Typography color='primary'>
                <b>CNPJ</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatDocument(newRegister?.documentId)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'phone') && (
            <Row>
              <Typography color='primary'>
                <b>Telefone</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatPhone(newRegister?.phone)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'email') && (
            <Row>
              <Typography color='primary'>
                <b>Email</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.email}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'stateSubscription') && (
            <Row>
              <Typography color='primary'>
                <b>Inscrição Estadual</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.stateSubscription}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'streetType') && (
            <Row>
              <Typography color='primary'>
                <b>Tipo do local</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.streetType}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'postalCode') && (
            <Row>
              <Typography color='primary'>
                <b>CEP</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {formatPostalCode(newRegister?.postalCode)}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'street') && (
            <Row>
              <Typography color='primary'>
                <b>Endereço</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.street}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'number') && (
            <Row>
              <Typography color='primary'>
                <b>Número</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.number}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'complement') && (
            <Row>
              <Typography color='primary'>
                <b>Complemento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.complement}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'city') && (
            <Row>
              <Typography color='primary'>
                <b>Cidade</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.city}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'district') && (
            <Row>
              <Typography color='primary'>
                <b>Bairro</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.district}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'state') && (
            <Row>
              <Typography color='primary'>
                <b>UF</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.state}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'simpleNational') && (
            <Row>
              <Typography color='primary'>
                <b>Simples Nacional</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.simpleNational == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'taxationRegime') && (
            <Row>
              <Typography color='primary'>
                <b>Regime Tributário</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationRegime?.find(type => +type?.value == +newRegister?.taxationRegime)?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'taxationRegimeSpecial') && (
            <Row>
              <Typography color='primary'>
                <b>Regime Tributário Especial</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationRegimeSpecial?.find(type => +type?.value == +newRegister?.taxationRegimeSpecial)?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'taxIncentive') && (
            <Row>
              <Typography color='primary'>
                <b>Incentivo Tributário</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.taxIncentive == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'encouraging') && (
            <Row>
              <Typography color='primary'>
                <b>Incentivador Cultural</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.encouraging == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'tokenCsc') && (
            <Row>
              <Typography color='primary'>
                <b>Token CSC</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.nfce?.tokenCsc}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'idTokenCsc') && (
            <Row>
              <Typography color='primary'>
                <b>ID Token</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {newRegister?.nfce?.idTokenCsc}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'pisAliquot') && (
            <Row>
              <Typography color='primary'>
                <b>Alíquota PIS</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {numericFormatter(newRegister?.nfce?.pisAliquot?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'pisCst') && (
            <Row>
              <Typography color='primary'>
                <b>CST Pis</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationSituations?.find(type => type?.value?.toString() == newRegister?.nfce?.pisCst?.toString())?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'cofinsAliquot') && (
            <Row>
              <Typography color='primary'>
                <b>Alíquota Cofins</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {numericFormatter(newRegister?.nfce?.cofinsAliquot?.toString() || '0', { thousandSeparator: '.', decimalSeparator: ',', decimalScale: 2, fixedDecimalScale: 2 })}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister?.nfce || {}, 'cofinsCst') && (
            <Row>
              <Typography color='primary'>
                <b>CST Cofins</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {taxationSituations?.find(type => type?.value?.toString() == newRegister?.nfce?.cofinsCst?.toString())?.label}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newConfigs || {}, 'serviceOrders') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as ordens de serviços pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.serviceOrders == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newConfigs || {}, 'invoices') && (
            <Row>
              <Typography color='primary'>
                <b>Todas as faturas de cliente pagas</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.invoices == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newConfigs || {}, 'selectedTransactions') && (
            <Row>
              <Typography color='primary'>
                <b>Emissão quando solicitada a nota fiscal</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newConfigs?.selectedTransactions == 0 ? 'Não' : 'Sim'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newConfigs || {}, 'paymentMethods') && (
            <Row>
              <Typography color='primary'>
                <b>Meios de pagamento</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {paymentMethods?.filter(paymentMethod => newConfigs?.paymentMethods?.includes(+paymentMethod?.value))?.map(paymentMethod => paymentMethod?.label)?.join(', ') || '--'}
              </Typography>
            </Row>
          )}
          {Object.prototype.hasOwnProperty.call(newRegister || {}, 'nfeStatus') && (
            <Row>
              <Typography color='primary'>
                <b>NFe Status</b>
              </Typography>
              <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                {+newRegister?.nfeStatus == 0 ? 'Desativado' : 'Ativado'}
              </Typography>
            </Row>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}